import { Component, Input } from '@angular/core'
import { NgClass } from '@angular/common';
import { NgCircleProgressModule } from 'ng-circle-progress'

import { ResponsiveComponent } from '@nx-superprep/shared'
import { Concept } from '@nx-superprep/backend/firebase'

@Component({
  selector: 'pop-ui-lesson-tile-term',
  standalone: true,
  imports: [NgClass, NgCircleProgressModule],
  templateUrl: './term.component.html',
  styleUrls: ['./term.component.scss'],
})
export class LessonTileTermComponent extends ResponsiveComponent {
  @Input() term!: Concept
  get radius() {
    return 16
  }

  get outerStrokeWidth() {
    return 2
  }

  get innerStrokeWidth() {
    return 2
  }

  get percent() {
    return this.count > 0 ? 100 * this.term.progress : 0
  }

  get label() {
    return ''
  }

  get name() {
    return this.term.title
  }

  get translation() {
    return this.term.description ?? ''
  }

  get progress() {
     return this.term.progress * this.term.cardCount || 0
  }

  get count() {
    return this.term.cardCount || 0
  }
}
